import Paragraph, { StyledParagraph } from './dist/index.es'

export { StyledParagraph }
export default Paragraph
